import { motion } from "framer-motion";
import { PropsWithChildren } from "react";
import clsx from "clsx";

type Props = PropsWithChildren<{ className?: string; delay?: number }>;

export const GlassMorphCard = ({ className, delay = 0, children }: Props) => (
  <motion.div
    initial={{ opacity: 0, y: 12 }}
    animate={{ opacity: 1, y: 0 }}
    transition={{ duration: 0.3, ease: "easeOut", delay }}
    className={clsx("glass rounded-xl2 p-4", className)}
  >
    {children}
  </motion.div>
);
